import axios, { AxiosResponse } from "axios";
import JefeEquipo from "../models/jefeEquipo.model";
import { General } from "./general";

export function JefeEquiposService(props?: any) {
    const getJefeEquipos = async (): Promise<AxiosResponse<JefeEquipo[]>> => {
        return axios.get<JefeEquipo[]>(`${General.API_URL}/GetJefeEquipos`);
    }
    return (
        {
            getJefeEquipos,
        }
    );
}
